import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = unauthenticated, object = authed

  useEffect(() => {
    const wantsEditor = new URLSearchParams(window.location.search).get("edit") === "1";
    if (!window.location.pathname.startsWith("/admin") && !wantsEditor) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        const adminPath = window.location.pathname.startsWith("/admin");
        setUser(adminPath && r.data.role !== "admin" ? false : r.data);
      })
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.user?.role !== "admin") {
        return { ok: false, error: "Bu panele erişim yetkiniz yok" };
      }
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {
      /* ignore logout errors */
    }
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
